const separatorCharacter = ',';

const cleanEmptyValues = (data: Map<string, string>) =>
  Array.from(data).reduce((prev: any[], [key, value]) => {
    if (!value) {
      return [...prev];
    }

    return [...prev, { [key]: value.split(separatorCharacter) }];
  }, []);

export const getConnectionType = ({ data }: { data: any }) => {
  const connectionTypes = new Map<string, string>([
    ['mxpeg', data?.CompressionTypes?.MXPEG?.MxpegConnectionType],
    ['h265', data?.CompressionTypes?.H265?.H265ConnectionType],
    ['h264', data?.CompressionTypes?.H264?.H264ConnectionType],
    ['mjpeg', data?.CompressionTypes?.MJPEG?.MjpegConnectionType],
    ['mpeg4', data?.CompressionTypes?.MPEG4?.Mpeg4ConnectionType],
    ['mpeg2', data?.CompressionTypes?.MPEG2?.Mpeg2ConnectionType],
  ]);

  return cleanEmptyValues(connectionTypes);
};

export const getMotionDetection = ({ data }: { data: any }) => {
  const motionDetections = new Map<string, string>([
    ['mxpeg', data?.CompressionTypes?.MXPEG?.MxpegMotionDetection],
    ['h265', data?.CompressionTypes?.H265?.H265MotionDetection],
    ['h264', data?.CompressionTypes?.H264?.H264MotionDetection],
    ['mjpeg', data?.CompressionTypes?.MJPEG?.MjpegMotionDetection],
    ['mpeg4', data?.CompressionTypes?.MPEG4?.Mpeg4MotionDetection],
    ['mpeg2', data?.CompressionTypes?.MPEG2?.Mpeg2MotionDetection],
  ]);

  return cleanEmptyValues(motionDetections);
};

const sortResolutions = (a: string, b: string) => {
  const SEPARATOR = 'x';

  const sumA = a
    .split(SEPARATOR)
    .reduce((prev: number, curr: string) => Number(prev) + Number(curr), 0);
  const sumB = b
    .split(SEPARATOR)
    .reduce((prev: number, curr: string) => Number(prev) + Number(curr), 0);

  return sumA - sumB;
};

export const getSupportedResolutions = (arg = ''): string => {
  const SEPARATOR = ', ';

  return arg.trim().split(SEPARATOR).sort(sortResolutions).join(SEPARATOR);
};

export const getPTZSupported = (PtzMotorAttributes: string) => {
  return PtzMotorAttributes?.toLowerCase().includes('pan-tilt') ? 'Yes' : 'No';
};

export const getSecurity = (security: string): string[] => {
  return security?.trim().split(separatorCharacter);
};
